import { Component, useState } from "react";
import ReactPlayer from "react-player";
import {
  Row,
  Col,
  Accordion,
  Card,
  Carousel,
  Modal,
  ListGroup
} from "react-bootstrap";
import { ChevronUp, ChevronDown, Download, Check } from "react-bootstrap-icons";
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import styled from "styled-components";
import ContactForm from "./contact-form";
import Footer from "./footer.js";
import LandingBanner from "./landing-banner";

import Efficiency from "./images/surdialDX/SD_Efficiency.jpeg";
import Differentiation from "./images/surdialDX/clinicalDifferentiation.jpeg";
import PatientSafety from "./images/surdialDX/SDX_Patient_Safety.jpeg";
import PatientExperience from "./images/surdialDX/SURDIAL-DX-Hemodialysis-System_Patient_Experience_08192025a.jpg";
import ClinicalHero from "./images/surdialDX/Clinical_Hero.jpg";
import BiomedHero from "./images/surdialDX/Biomed_Hero.png";
import ClinicalHeroLabeled from "./images/surdialDX/clinicalLabeled.PNG";
import BiomedHeroLabeled from "./images/surdialDX/biomedLabeled.PNG";
import ThreeSixtymachine from "./images/surdialDX/360machine.jpeg";
import Easeofmaintenance from "./images/surdialDX/SDX_Ease_Of_Mainitenance.jpeg";
import SafetyProtocols from "./images/surdialDX/safetyProtocols.jpeg";
import SuperiorService from "./images/surdialDX/superiorService.jpeg";

import EfficiencyZoomed from "./images/surdialDX/efficiencyBigPicture.png";
import EnhancedWorkflow from "./images/surdialDX/enhancedWorkflow.jpg";
import ErgonomicDesign from "./images/surdialDX/ergonomicDesign.png";
import PatientSafetyZoomed from "./images/surdialDX/patientSafety.png";

import SDXBrochure from "./msds/SDX/NiproHemodialysisSystemBrochure.pdf";
import SDXBrochureClinical from "./msds/SDX/NiproHemodialysisSystemBookletClinical.pdf";
import SDXBrochureBiomed from "./msds/SDX/NiproHemodialysisSystemBookletBiomed.pdf";

function ControlledCarousel() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
const StyledCarouselItem = styled(Carousel.Item)`
min-height: 300px !important;
background-color: white;

@media only screen and (max-width: 768px) {
  min-height: 515px !important;
`;
    var firstAccordionArrow = false;
    var secondAccordionArrow = false;
    var thirdAccordionArrow = false;
    var fourthAccordionArrow = false;
  return (
    
    <Row><Col  sm={12} md={6} lg={6}>
    <Carousel interval={null} activeIndex={index} onSelect={handleSelect}>
      <StyledCarouselItem >
                            <img
                      src={Efficiency}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />
      </StyledCarouselItem>
      <StyledCarouselItem>
                            <img
                      src={Differentiation}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />        
      </StyledCarouselItem>
      <StyledCarouselItem>
                            <img
                      src={PatientSafety}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />
      </StyledCarouselItem>
      <StyledCarouselItem>
                            <img
                      src={PatientExperience}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />
      </StyledCarouselItem>  
    </Carousel>
  </Col>  
    <Col sm={12} md={6} lg={6} id="servicesheaderp">
      <Accordion flush >
            {/*Accordion 1*/}
            <Card >
            <Card.Header className="accordionHeader" onClick={() => setIndex(0)}>
                <CustomToggle eventKey={"efficiency"} inputVariable={firstAccordionArrow}>     
                <b>EFFICIENCY</b>
                </CustomToggle>
            </Card.Header>
              <Accordion.Collapse eventKey={"efficiency"} >
              <Card.Body>
                    <p className="tabText">
              <ul>
                  <li>Streamlined, automated time saving processes</li>
                  <li>Intuitive, on-screen guidance to minimize human error</li>
                  <li>Reduced preparation and disinfection time</li>
                  <li>Efficient, low disinfectant consumption</li>
                  <li>Automatic, programable system wake-up function</li>
                  <li>Confidence-building continuous professional training</li>
                <li> Compact, space-saving design</li>
              </ul>
                    </p>
                    <br />
                    <br />
                    </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/*Accordion 2*/}
            <Card >
            <Card.Header className="accordionHeader" onClick={() => setIndex(1)}>
                <CustomToggle eventKey={"clinical-differentiation"} inputVariable={secondAccordionArrow}>     
                  <b>CLINICAL DIFFERENTIATION</b>
                </CustomToggle>
            </Card.Header>
              <Accordion.Collapse eventKey={"clinical-differentiation"} >
              <Card.Body>            
                <p className="tabText">
<ul>
    <li>Automatic blood pump segment loading</li>
    <li>Ability to setup during startup test</li>
    <li>Auto priming function</li>
    <li>Estimated and measured Kt/V values</li>
    <li>Ergonomic design with rotatable monitor</li>
    <li>Large wheels for ease of maneuverability</li>
</ul>
                    </p>
                    </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/*Accordion 3*/}
            <Card >
            <Card.Header className="accordionHeader" onClick={() => setIndex(2)}>
                <CustomToggle eventKey={"patient-safety"} inputVariable={thirdAccordionArrow}>     
                <b>PATIENT SAFETY</b>
                </CustomToggle>
            </Card.Header>              
              <Accordion.Collapse eventKey={"patient-safety"} >
              <Card.Body>
                <p className="tabText">
<ul>
    <li>Built in safety monitoring systems</li>
    <li>Aseptic priming to built-in drain port</li>
    <li>Maximum set blood flow rate for rinse-back</li>
    <li>Front and internal leakage detector</li>
    <li>Venous/arterial pressure monitoring</li>
</ul>
                    </p>
</Card.Body>
              </Accordion.Collapse>
            </Card>
            {/*Accordion 4*/}
            <Card >
            <Card.Header className="accordionHeader" onClick={() => setIndex(3)}>
                <CustomToggle eventKey={"patient-experience"} inputVariable={fourthAccordionArrow}>     
                  <b>PATIENT EXPERIENCE</b>
                </CustomToggle>  
            </Card.Header>
              <Accordion.Collapse eventKey={"patient-experience"} >
              <Card.Body>              
                    <p className="tabText">
<ul>
    <li>Quiet running system operation</li>
    <li>Soft, patient-friendly alarm sound</li>
    <li>Adjustable cuff inflation pressure</li>
    <li>Treatment progress display</li>
</ul>
                    </p>
</Card.Body>
              </Accordion.Collapse>
            </Card>
            </Accordion>
    </Col>
    </Row>
  );
}
const StyledChevronUp = styled(ChevronUp)`
  position: absolute;
  right: 0;
  margin-right: 0.4em;
  margin-top: 0.3em;
`;
const StyledChevronDown = styled(ChevronDown)`
  position: absolute;
  right: 0;
  margin-right: 0.4em;
  margin-top: 0.4em;
`;
const StyledPlayer = styled(ReactPlayer)`
        width: 50%;
        margin-left: auto;
        margin-right: auto;
`;
const StyledDownload = styled(Download)`
  margin-right: 20px;
`;

function CustomToggle({ children, eventKey, inputVariable}){
  const [isActive, setIsActive] = useState(inputVariable);
  //globalvariable is currently undefined
  const decoratedOnClick = useAccordionButton(eventKey, () =>
  [setIsActive(isActive => !isActive)],
  );

  return (
    <button
      type="button"
      class="accordionButton"
      onClick={decoratedOnClick}
    >
      {[children]}
      {isActive ? <StyledChevronUp size={20}/>: <StyledChevronDown size={20}/>}
    </button>
  );
}
function CustomToggleSmall({ children, eventKey, inputVariable}){
  const [isActive, setIsActive] = useState(inputVariable);
  //globalvariable is currently undefined
  const decoratedOnClick = useAccordionButton(eventKey, () =>
  [setIsActive(isActive => !isActive)],
  );

  return (
    <button
      type="button"
      class="accordionButtonSmall"
      onClick={decoratedOnClick}
    >
      {[children]}
      {isActive ? <StyledChevronUp size={20}/>: <StyledChevronDown size={20}/>}
    </button>
  );
}

function CustomModal() {
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [index, setIndex] = useState(0);
  const [index2, setIndex2] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
      var firstAccordionArrow = false;
    var secondAccordionArrow = false;
    var thirdAccordionArrow = false;
    var fourthAccordionArrow = false;
      const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };
  const handleSelect2 = (selectedIndex) => {
    setIndex2(selectedIndex);
  };
  const StyledCarouselItem = styled(Carousel.Item)`
min-height: 300px !important;
background-color: white;

@media only screen and (max-width: 768px) {
  min-height: 515px !important;
`;
  return (
    <>
    <Row style={{  maxWidth: "90%", textAlign: "center"}}>
      <Col className="align-items-left">             
    <img src={ClinicalHeroLabeled} 
                      className={"img-responsive tabImgWithOnHover"}
                      id="smallTabImg"
                      alt="Clinical"
                      onClick={() => setShow(true)}/>

      <Modal
        show={show}
        onHide={() => setShow(false)}

        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            <h1>Clinical</h1><h6>CLINICIAN-INSPIRED. PATIENT-FOCUSED.</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
<Carousel interval={null} activeIndex={index} onSelect={handleSelect} >
      <StyledCarouselItem >
                            <img
                      src={ClinicalHero}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />
      </StyledCarouselItem>
      <StyledCarouselItem >
                            <img
                      src={EfficiencyZoomed}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />
      </StyledCarouselItem>
      <StyledCarouselItem>
                            <img
                      src={EnhancedWorkflow}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />        
      </StyledCarouselItem>
      <StyledCarouselItem>
                            <img
                      src={ErgonomicDesign}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />
      </StyledCarouselItem>
      <StyledCarouselItem>
                            <img
                      src={PatientSafetyZoomed}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />
      </StyledCarouselItem>  
      </Carousel>
            </Col>
          <Col>
Developed with clinician insights, SURDIAL™ DX is designed to be efficient and ergonomic. Its 15-inch screen can be rotated and tilted for comfortable viewing and has a highly visible screensaver that features a treatment progress display. Along with a user-friendly interface, the machine’s automation provides an enhanced workflow, which is supported by step-by-step on-screen guidance. 
This streamlines processes and allows clinicians to optimize their time. With a dependable partner like Nipro, clinicians can trust Surdial™ DX. EXPERIENCE THE DIFFERENCE.
<br />
          <p>
             <Accordion flush >
            {/*Accordion 1*/}
            <Card >
            <Card.Header className="accordionHeader" onClick={() => setIndex(1)}>
                <CustomToggleSmall eventKey={"efficiency"} inputVariable={firstAccordionArrow}>     
                <b><Check></Check>EFFICIENCY</b>
                </CustomToggleSmall>
            </Card.Header>
              <Accordion.Collapse eventKey={"efficiency"} >
              <Card.Body>
                    <p className="tabText">
              <ul>
                  <li>Ability to Setup During Startup Test</li>
                  <li>Auto Priming</li>
                  <li>Auto Power On</li>
                  <li>On-Screen Guidance</li>
              </ul>
                    </p>
                    </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/*Accordion 2*/}
            <Card >
            <Card.Header className="accordionHeader" onClick={() => setIndex(2)}>
                <CustomToggleSmall eventKey={"clinical-differentiation"} inputVariable={secondAccordionArrow}>     
                  <b><Check></Check>ENHANCED WORKFLOW</b>
                </CustomToggleSmall>
            </Card.Header>
              <Accordion.Collapse eventKey={"clinical-differentiation"} >
              <Card.Body>            
                <p className="tabText">
<ul>
    <li>Estimated and real time Kt/V:</li>
    <li>Programable assist to achedule post-BUN</li>
    <li>Additional timers</li>
    <li>Estimated and measured Kt/V values</li>
    <li>Permanent central concentrate connection</li>
    <li>Aseptic priming directly into a built-in drain port</li>
</ul>
                    </p>
                    </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/*Accordion 3*/}
            <Card >
            <Card.Header className="accordionHeader" onClick={() => setIndex(3)}>
                <CustomToggleSmall eventKey={"patient-safety"} inputVariable={thirdAccordionArrow}>     
                <b><Check></Check>ERGONOMIC DESIGN</b>
                </CustomToggleSmall>
            </Card.Header>              
              <Accordion.Collapse eventKey={"patient-safety"} >
              <Card.Body>
                <p className="tabText">
<ul>
    <li>Large status indicator</li>
    <li>Rotatable and tiltable monitor</li>
    <li>Large wheels for easier maneuverability</li>
    <li>Front and internal leakage detector</li>
    <li>Quiet running</li>
</ul>
                    </p>
</Card.Body>
              </Accordion.Collapse>
            </Card>
            {/*Accordion 4*/}
            <Card >
            <Card.Header className="accordionHeader" onClick={() => setIndex(4)}>
                <CustomToggleSmall eventKey={"patient-experience"} inputVariable={fourthAccordionArrow}>     
                  <b><Check></Check>PATIENT SAFETY</b>
                </CustomToggleSmall>  
            </Card.Header>
              <Accordion.Collapse eventKey={"patient-experience"} >
              <Card.Body>              
                    <p className="tabText">
<ul>
    <li>First Aid Button</li>
    <li>Blood Pressure Link to Treatment Condition</li>
    <li>20-Minute Backup Battery</li>
    <li>Leakage Detector</li>
    <li>Rinse-Back Safety Settings</li>
</ul>
                    </p>
</Card.Body>
              </Accordion.Collapse>
            </Card>
            </Accordion>

          </p>
          <ListGroup>
              <ListGroup.Item style={{  backgroundColor: "#00B5E2", color: "white"}}>
                DOCUMENTATION
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={SDXBrochure + "?pdf=sdx%brochure"}
                  download
                ><StyledDownload size={20} />
                  SURDIAL DX Hemodialysis System Brochure 
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={SDXBrochureClinical + "?pdf=sdx%brouchure%clinical"}
                  download
                ><StyledDownload size={20} />
                  SURDIAL DX Hemodialysis System Booklet (Clinical)
                </a>
              </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
</Col>
<Col className="align-items-right">
    <img src={BiomedHeroLabeled} 
                      className="img-responsive tabImgWithOnHover"
                      id="smallTabImg"
                      alt="Clinical"
                      onClick={() => setShow2(true)}/>
      <Modal
        show={show2}
        onHide={() => setShow2(false)}

        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            <h1>BIOMED</h1><h6>WHERE HIGH QUALITY MEETS EXCEPTIONAL SERVICE</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
<Carousel interval={null} activeIndex={index2} onSelect={handleSelect2} >
      <StyledCarouselItem >
                            <img
                      src={BiomedHero}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Biomed Hero"
                    />
      </StyledCarouselItem>
      <StyledCarouselItem >
                            <img
                      src={ThreeSixtymachine}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />
      </StyledCarouselItem>
      <StyledCarouselItem>
                            <img
                      src={Easeofmaintenance}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />        
      </StyledCarouselItem>
      <StyledCarouselItem>
                            <img
                      src={SafetyProtocols}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />
      </StyledCarouselItem>
      <StyledCarouselItem>
                            <img
                      src={SuperiorService}
                      className="img-responsive tabImgNoShadow"
                      id="smallTabImg"
                      alt="Repair Center"
                    />
      </StyledCarouselItem>  
      </Carousel>
            </Col>
          <Col>
The SURDIALTM DX Hemodialysis System is ergonomically designed to provide ease of maintenance through a high level of serviceability, 
including 360-degree access to all parts of the machine. Innovative design and quality are complemented with services like 24/7 support, 
and in-person professional training before and after delivery. 
Experience the difference in the SURDIAL DX dependable service and ease of maintenance.
          <p>
                 <Accordion flush >
            {/*Accordion 1*/}
            <Card >
            <Card.Header className="accordionHeader" onClick={() => setIndex2(1)}>
                <CustomToggleSmall eventKey={"efficiency"} inputVariable={firstAccordionArrow}>     
                <b><Check></Check>360-DEGREE ACCESSIBILITY</b>
                </CustomToggleSmall>
            </Card.Header>
              <Accordion.Collapse eventKey={"efficiency"} >
              <Card.Body>
                    <p className="tabText">
All doors open like panels and all the components are easily accessible.
                    </p>
                    <br />
                    </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/*Accordion 2*/}
            <Card >
            <Card.Header className="accordionHeader" onClick={() => setIndex2(2)}>
                <CustomToggleSmall eventKey={"clinical-differentiation"} inputVariable={secondAccordionArrow}>     
                  <b><Check></Check>PREVENTIVE MAINTENANCE (PM)</b>
                </CustomToggleSmall>
            </Card.Header>
              <Accordion.Collapse eventKey={"clinical-differentiation"} >
              <Card.Body>            
                <p className="tabText">
PM is every 2 years or 8,000 hours; whichever comes first. PM hours are tracked by the machine which generates reminders for upcoming preventative maintenance.
                    </p>
                    <br />
                    </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/*Accordion 3*/}
            <Card >
            <Card.Header className="accordionHeader" onClick={() => setIndex2(3)}>
                <CustomToggleSmall eventKey={"patient-safety"} inputVariable={thirdAccordionArrow}>     
                <b><Check></Check>INTERNAL & EXTERNAL LEAK DETECTOR</b>
                </CustomToggleSmall>
            </Card.Header>              
              <Accordion.Collapse eventKey={"patient-safety"} >
              <Card.Body>
                <p className="tabText">
Senses leaks inside the machine from hydraulics and from the extracorporeal circuit on the front of the machine.
This function not only prevents further damage to the machine in the event of a leak, but also ensures overall safety, preventing hazards from the wet floor.
                    </p>
                    <br />
</Card.Body>
              </Accordion.Collapse>
            </Card>
            {/*Accordion 4*/}
            <Card >
            <Card.Header className="accordionHeader" onClick={() => setIndex2(4)}>
                <CustomToggleSmall eventKey={"patient-experience"} inputVariable={fourthAccordionArrow}>     
                  <b><Check></Check>INTERACTIVE HYDRAULIC FLOW CONTROL</b>
                </CustomToggleSmall>  
            </Card.Header>
              <Accordion.Collapse eventKey={"patient-experience"} >
              <Card.Body>              
                    <p className="tabText">
Operate components of the hydraulic circuit from the touchscreen for quick and easy troubleshooting. 
                    </p>
                    <br />
</Card.Body>
              </Accordion.Collapse>
            </Card>
            </Accordion>
          </p>
          <ListGroup>
              <ListGroup.Item style={{  backgroundColor: "#00B5E2", color: "white"}}>
                DOCUMENTATION
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={SDXBrochure + "?pdf=sdx%brochure"}
                  download
                ><StyledDownload size={20} />
                  SURDIAL DX Hemodialysis System Brochure 
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  href={SDXBrochureBiomed + "?pdf=sdx%brouchure%biomed"}
                  download
                ><StyledDownload size={20} />
                  SURDIAL DX Hemodialysis System Booklet (Biomed)
                </a>
              </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
</Col>
      </Row>
    </>
  );
}

class SurdialDX extends Component {
  render() {
    const VideoDemoCardButton = styled.button`
      background-color: #FF4337;
      border: none;
      color: white;
      padding: 16px 32px;
      text-align: center;
      font-size: 16px;
      margin: 15px;
      opacity: 1;
      transition: 0.3s;
      border-radius: 15px;
      top: 50%;
      left: 50%;
    align-content: center;
      &:hover {
        background-color: #fa7b73;
      }
    `;
    return (
      <div>
        <br />
        <br />

            <div class="jumbotron">
                <ControlledCarousel></ControlledCarousel>
            </div>
                <div style={{ textAlign: "center" }}><h3>Schedule Your SURDIAL™ DX Demo Today! </h3>
                  <br />                          
                            <VideoDemoCardButton>
                            <a
                                    href="https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=yZ61zV7aiEKPav757gS-nSlEXTjpGhhEviQPsXQp-EBUMDM2STNHTEM1OUJPMVRKMDZQWTAzTUxQQi4u"
                                    rel="noreferrer"
                                    style={{ color: "white" }}
                                    target="_blank"
                                  >
                                    {" "}
                                    Schedule Demo
                                  </a>
                                  </VideoDemoCardButton>
                                  </div> 
          <div class="jumbotron">
              <StyledPlayer
                      className="react-player"
                      url="https://www.youtube.com/watch?v=MQBRMgAdXag"
                    />      
          </div>
          <h1 id="FocusText">Focus</h1>
          <div class="jumbotron">
          <CustomModal></CustomModal>
          </div>
        <LandingBanner />
        <ContactForm />
        <LandingBanner />
        <Footer />
      </div>
    );
  }
}

export default SurdialDX;
